import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import {Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';
import {Observable, throwError} from 'rxjs';

import {AuthService} from './auth/auth.service';
import {catchError, map, retry, tap} from 'rxjs/operators';

import {FuseProgressBarService} from '@fuse/components/progress-bar/progress-bar.service';

import {ToastrService} from 'ngx-toastr';
import {environment} from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {
  private authService: AuthService;

  constructor(
    private injector: Injector,
    private _fuseProgressBarService: FuseProgressBarService,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.authService = this.injector.get(AuthService);

    const token: string = this.authService.getToken();

    // console.log('Httprequest:', request.url);
    this._fuseProgressBarService.show();

    // console.log('!!!!!>', request.url);
    // https://inbe-dashboard-data.s3.us-west-2.amazonaws.com/dev/64f65042-4788-479a-a621-f302d6f326ac.json?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIYE4KJRVENVCAR3A%2F20210716%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20210716T003144Z&X-Amz-Expires=900&X-Amz-Signature=594fb46d13ad6609bf83186f0786c1a523d12d3c483acbc3512efa19c628bcea&X-Amz-SignedHeaders=host
    // https://inbe-emails-campaigns.s3.ca-central-1.amazonaws.com/dev/c6586476-480e-4279-8fb9-dad080b7ab43.json
    //
    // Pour éviter de passer le token sur certaines url...
    //
    if (
      request.url.startsWith('https://inbe-tmp-files') ||
      request.url.startsWith('https://inbe-dashboard-data') ||
      request.url.startsWith('https://inbe-emails-campaigns') ||
      request.url.startsWith('https://inbe-emails-body') ||
      request.url.includes('assets')
    ) {
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          pragma: 'public',
        },
      });
    } else {

      // console.log('Inject Token in HTTP Flow', token);

      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
    }
    // return next
    //   .handle(request)
    //   .pipe(
    //     retry({
    //       count: 5,
    //       delay: 1000
    //     }),
    //     map((event: HttpEvent<any>) => {
    //         return event;
    //       }
    //     ),
    //     catchError((err: any) => {
    //       return throwError(err);
    //     }),
    //   );
    return next.handle(request);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private _fuseProgressBarService: FuseProgressBarService,
    private toastr: ToastrService,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      retry({count: 2, delay: 1000}),
      tap((evt) => {
        // this._fuseProgressBarService.hide();
        // console.log('Event', evt);
        if (evt instanceof HttpResponse) {
          // if (evt.body && evt.body.success) {
          this._fuseProgressBarService.hide();
          // this.toasterService.success(evt.body.success.[8] - message, evt.body.success.title, { positionClass: 'toast-bottom-center' });
          // }
        }
      }),
      catchError((response: any) => {
        this._fuseProgressBarService.hide();

        if (response instanceof HttpErrorResponse) {
          const errorMessageExceptions = [
            'Username/Password is not correct',
            'No principalId set on the Response',
          ];

          let doNotDisaplyToastr = false;
          try {
            doNotDisaplyToastr = errorMessageExceptions.includes(response.error.error.message);
          } catch (error) {
            doNotDisaplyToastr = false;
          }

          let message = '';
          try {
            if (response.error.error.message) {
              message = response.error.error.message;
            }
          } catch (error) {
            message = response.message;
          }

          // console.log(response);

          if (!doNotDisaplyToastr) {
            this.toastr.error(message, 'Something goes wrong!', {
              timeOut: 15000,
              progressBar: true,
              enableHtml: true,
            });
          }

          // Swal.fire({
          //   icon: 'error',
          //   title: 'Oops... Error ' + response.status,
          //   text: 'Something went wrong!',
          //   footer: response.error.[8] - message
          // }).then((result) => {
          //   // localStorage.removeItem('token');
          //   // this.router.navigateByUrl('auth/login');
          // });
        }

        if (response instanceof HttpErrorResponse
          && (response.status === 401 || response.status === 403)
        ) {
          // console.log('Session expired ?');

          // this.toastr.warning('Please log-in again.', 'Invalid session', {
          //   timeOut: 15000,
          //   progressBar: true,
          //   enableHtml: true,
          // });

          //
          // console.log(response);
          const apiUrl = environment.apiUrl;
          //
          // Éviter de claquer une erreur quand c'est 'juste' des fichiers S3...
          // En fait, claquer une erreur que si c'Est une url de l'api qui est en cause :)
          // inbe-dashboard-data.s3.ca-central-1.amazonaws.com
          // https://dashboard-datas.inbe.ca/
          if (response.url.includes(apiUrl)) {
            localStorage.removeItem('token');
            this.router.navigateByUrl('/log-in');
          }

        }

        return throwError(response);
      }),
    );
  }
}
